import React, { useEffect, useState } from 'react'
import UserLayout from '../../../components/layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux'
import { fetchApplications } from '../../../store/actions/applicationsActions'
import Loader from '../../../components/elements/Loader'
import ApplicationCard from '../../../components/partials/applications/ApplicationCard'
import EmptyState from '../../../components/elements/EmptyState'
import { fetchAdmissions } from '../../../store/actions/admissionsActions'
import { transactionTimeStamp } from '../../../utils'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../../components/elements/icons/ArrowIcon'
import Pagination from '../../../components/elements/Pagination'

const Applications = () => {
  const dispatch = useDispatch()
  const applicationsSelector = useSelector((state => state.applications))
  const admissionsSelector = useSelector((state => state.admissions))
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  useEffect(() => {
    dispatch(fetchApplications('', page, perPage))
    dispatch(fetchAdmissions())
    return () => {
      
    };
  }, [page, perPage, dispatch]);

  return (
    <UserLayout>
      <div className='w-full pb-24'>
        <div className='w-full flex justify-between'>
          <div>
            <h3 className='text-lg font-medium'>Your Applications</h3>
            <p className='text-sm'>All applications for admission made by you to Vaatia College Makurdi</p>
          </div>
          <div>
            {/* <button className='rounded px-4 py-3 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple'>Create a new application</button> */}
          </div>
        </div>

        {applicationsSelector.loadingApplications ? 
          <Loader />
          :
          <>
            {applicationsSelector.applications.applications.length > 0 ? <>
              <div className='mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8'>
                {applicationsSelector.applications.applications.map((application, applicationIndex)=>(
                  <div key={applicationIndex}>
                    <ApplicationCard application={application} />
                  </div>
                ))}
              </div>
              <Pagination 
                pagination={{
                  perPage, 
                  currentPage: page,
                  totalItems: applicationsSelector.applications.total,
                }} 
                changePage={setPage} 
                updatePerPage={setPerPage}
              />
            </>
              : 
              <div className='mt-24 w-1/2 mx-auto'>
                <EmptyState emptyStateText={`You have not applied to Vaatia College Makurdi yet!`} />
                {admissionsSelector.admissions?.admissions?.length > 0 && 
                  <div className='mt-6 pt-6 border-t'>
                    <p className='text-sm mb-3'>We have the following opening(s) at the moment:</p>
                    {admissionsSelector.admissions?.admissions.map((admission, admissionIndex)=>(
                      <div key={admissionIndex} className='mt-5 py-5 border-t border-b'>
                        <p className='tracking-[0.2em] uppercase mb-2'>{admission.title} - {admission.type}</p>
                        <p className='text-sm'>Entry Classes: {admission.entryClasses.join(', ')}</p>
                        {/* <p className='text-sm'>Application Fee: <span className='capitalize text-gray-600 text-lg'>₦{(admission.fee.amount/100).toLocaleString()} </span></p> */}
                        <p className='text-sm'>Open from <span className='font-[600]'>{transactionTimeStamp(admission.startDate).date}</span> to  <span className='font-[600]'>{transactionTimeStamp(admission.endDate).date}</span></p>
                        
                        <Link to={`/user/admissions/${admission._id}`}>
                            <button className='text-sm flex flex-row items-center gap-x-3 mt-2 text-vcm-purple hover:text-gray-400 transition duration-200'>
                            Apply to this opening <ArrowIcon className={`w-4 h-4`} /></button> 
                        </Link>
                      </div>
                    ))}
                  </div>
                }
              </div>

            }
          </>
        }
      </div>
    </UserLayout>
  )
}

export default Applications